import React from 'react';
import { IconWand, IconLayoutDashboard, IconArrowLeft } from '@tabler/icons-react';

const AgentChoiceModal = ({ show, onChooseScratch, onChooseWizard, onBack }) => {
  if (!show) return null;

  return (
    <div className="awc-choice">
      <div className="awc-choice__container">
        {onBack && (
          <button
            className="awc-choice__back"
            onClick={onBack}
            title="Voltar"
          >
            <IconArrowLeft size={18} />
            Voltar
          </button>
        )}
        <h2 className="awc-choice__title">Como deseja criar seu agente?</h2>
        <p className="awc-choice__subtitle">
          Escolha a forma de criação que melhor se adapta ao seu momento.
        </p>

        <div className="awc-choice__grid">
          <div
            className="awc-choice__card"
            onClick={onChooseScratch}
            role="button"
            tabIndex={0}
            aria-label="Criar agente do zero no canvas visual"
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onChooseScratch(); } }}
          >
            <div className="awc-choice__card-icon awc-choice__card-icon--scratch">
              <IconLayoutDashboard size={32} />
            </div>
            <h3>Criar do Zero</h3>
            <p>Monte seu agente manualmente no canvas visual, com controle total sobre cada componente.</p>
          </div>

          <div
            className="awc-choice__card"
            onClick={onChooseWizard}
            role="button"
            tabIndex={0}
            aria-label="Criar agente com assistente inteligente"
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onChooseWizard(); } }}
          >
            <span className="awc-choice__badge">Recomendado</span>
            <div className="awc-choice__card-icon awc-choice__card-icon--wizard">
              <IconWand size={32} />
            </div>
            <h3>Criar com Assistente</h3>
            <p>A IA entende seu negócio e cria o agente completo em minutos. Ideal para quem está começando.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentChoiceModal;
